import { ProgressBar, Text } from '@ifood/pomodoro-components';

import { Wrapper } from './Stepper.styles';
import { StepperProps } from './Stepper.types';

export const Stepper: React.FC<StepperProps> = ({ steps, ...props }) => {
  if (!steps?.length) {
    return null;
  }

  return (
    <Wrapper {...props}>
      <Text color="grayDarkest" variant="small">
        {steps?.find((step) => step.variant === 'current')?.text}
      </Text>

      <ProgressBar
        activeIndex={steps?.findIndex((step) => step.variant === 'current') + 1}
        m={0}
        steps={steps?.length || 0}
        variant="segmented"
      />
    </Wrapper>
  );
};
